export default "__VITE_ASSET__CbOM7azJ__"